import { GameiomConfigSchema } from "gameiom/schema/gameiom-config-schema";
import { GameiomPlatformSchema } from "gameiom/schema/gameiom-platform-schema";

export interface AgsSpinResponseSchema {
    error: GameiomErrorSchema;
    publicState: AgsSpinPublicStateSchema;
    platform: GameiomPlatformSchema;
    config: GameiomConfigSchema;
}

export interface GameiomErrorSchema {
    code: string;
    message: string;
    stackTrace: string;
}

export interface AgsSpinPublicStateSchema {
    action: string;
    betAmount: number;
    denom: number;
    result: AgsResultSchema;
    recoveredGame?: AgsSpinPublicStateSchema;
}

export interface AgsResultSchema {
    type: string;
    totalSpinWin: number;
    wonAmount: number;
    reels: number[][];
    wins: AgsWin[];
    sumWins: number;
    childFeature: AgsResultSchema[] | AgsPickSchema[];
    complete: boolean;
    events: AgsEvent[];
    MCSymbols?: ValueSymbolSchema[];
    WildMultipliers?: WildMultiplierSchema[];
    freeSpinsLeft: number;
    totalFreeSpins: number;
    sumWinsFreeSpins: number;
    currentFeatureWin: number;
    BonusGame?: AgsPickBonusSchema;
    parentResult?: AgsResultSchema;
    action?: string;
    layout: string;
}

export interface AgsPickSchema {
    type: string;
    index: number;
    value: string;
    complete: boolean;
    cashWon: number;
    currentFeatureWin: number;
    BonusGame?: AgsPickBonusSchema;
}

export interface AgsPickBonusSchema {
    BetAmount: number;
    SelectedIndex: number;
    WinAmount: number;
    JackpotTypeIfWon?: string;
    CoinGrabGames?: AgsCoinGrabGameSchema[];
    MCSymbols?: ValueSymbolSchema[];
    cashCurrentlyAwarded?: number;
}

export interface AgsCoinGrabGameSchema {
    CoinsPicked: number;
    Complete: boolean;
    IsCoinGrabFinished: boolean;
    IsCoinGrabStarted: boolean;
    MysteryPrize: number;
    MysteryPrizeCombination: number[];
    MysteryPrizeString: number;
}

export interface AgsWin {
    winType: string;
    winAmount: number;
    winningSymbolsPositions: number[][];
    lineNumber: number;
    symbolId: number;
    multiplier: number;
    ways: number;
    freeSpinsAmount: number;
    featureType: string;
    bonusType?: number;
    jackpotoutcome?: string;
}

export interface AgsFeature {
    tbc: string;
}

export interface AgsEvent {
    id: string;
    positions?: number[][];
    upgrade?: boolean;
    state?: number;
    animationType?: number;
}

export enum AgsWinTypes {
    POWER_X_STREAM = "PowerXStream",
    SCATTER = "scatter",
    LINES = "lines",
    RANDOM = "random",
    FREESPIN = "freeSpin",
    JACKPOT = "jackpot"
}

export interface ValueSymbolSchema {
    coordinate: {
        Item1: number,
        Item2: number
    };
    Index: number;
    CashBonusState?: number;
    JPSymbolIfString?: string;
    IsLocked: boolean;
    IsCashBonus?: number;
    symbol: number;
    winAmount: number;
    Type: number;
}

export interface WildMultiplierSchema {
    Index: number;
    Coordinate: { Item1: number, Item2: number };
    Multiplier: number;
}

export interface HoldAndSpinSchema extends AgsPickSchema {
    MCSymbols: ValueSymbolSchema[];
    freeSpinsLeft: number;
    freeSpinsspun: number;
    BonusNumber: number;
}

export enum AgsFeatureTypes {
    FIVE_OF_A_KIND = "fiveofakind",
    FREESPINS_WIN = "freeSpinWin",
    PICK = "pick",
    JACKPOT = "jackpot"
}
